export const calculateGenderScore = (maleCount, femaleCount) => {
    if (femaleCount + maleCount === 0 || femaleCount === maleCount) {
        return 1
    }
    if (femaleCount === 0 || maleCount === 0) {
        return Math.cos(
            (Math.PI *
                Math.min(Math.abs(maleCount - femaleCount) * 0.2, 1)) /
                2,
        )
    }
    if (maleCount + femaleCount < 10) {
        return Math.cos(
            (Math.PI *
                Math.min(Math.abs(maleCount - femaleCount) * 0.2, 1)) /
                2,
        )
    }
    return Math.cos(
        (Math.PI *
            Math.min(
                Math.abs(maleCount - femaleCount) /
                    (0.33 * (maleCount + femaleCount)),
                1,
            )) /
            2,
    )
}
